<!--维修订单上传图片页-->
<template>
    <div id="that">
        <div style="padding: 10px 0px 0px 0px">
            <van-icon name="arrow-left" style="float: left" size="20px" @click="onback"/>
        </div>

        <div style="padding-top: 20px">
            <Button @click="changediv" :type="changebefore">维修前</Button>
            <Button @click="changediv" :type="changeafter">维修后</Button>
        </div>
        <div>
            <Select v-model="MaintainPicture.id" @on-change="getpicture">
                <Option v-for="item in maintainpeList" :value="item.id" :key="item.id">{{item.positioningDeviceInfo.terminalNum}}</Option>
            </Select>
        </div>

        <!--    维修前图片    -->
        <div v-if="showdiv">
            维修前
            <div style="height: 40px"></div>
            <div class="demo-upload-list" v-for="item in uploadList">
                <template v-if="item.status === 'finished'">
                    <img :src="item.url">
                    <div class="demo-upload-list-cover">
                        <Icon type="ios-eye-outline" @click.native="handleView(item.name)"></Icon>
                        <!--     不设删除   -->
                        <!--        <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>-->
                    </div>
                </template>
                <template v-else>
                    <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                </template>
            </div>
            <!--  iview的组件  -->
            <Upload
                    ref="upload"
                    :show-upload-list="false"
                    :default-file-list="defaultList"
                    :on-success="handleSuccess"
                    :on-error="handleerror"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload"
                    type="select"
                    action="https://upload-z2.qiniup.com"
                    multiple
                    style="display: inline-block;width:58px;">
                <div style="width: 58px;height:58px;line-height: 58px;">
                    <Icon type="ios-camera" size="20"></Icon>
                </div>
            </Upload>
            <Modal title="图片预览" v-model="visible">
                <!--      <img :src="imageurl" v-if="visible" style="width: 100%">-->
                <!--   <img :src="'https://pic.jianchengjt.com/' + item.picKey + '?imageView2/2/w/300/h/200'">-->


                <img @click="onPhotoClick"
                     :src="'https://pic.jianchengjt.com/' + itempicKey + '?imageView2/2/w/300/h/200'"></img>


            </Modal>
            <!--        <div v-if="uploadFile !== null">上传文件: {{uploadFile.name}}-->
            <!--            <van-button type="info" @click="upload" :loading="loadingStatus">{{loadingStatus?'正在上传':'点击上传文件'}}-->
            <!--            </van-button>-->
            <!--        </div>-->
            <div v-if="uploadFile.length > 0" v-for="item in uploadFile">上传文件: {{item.file.name}}</div>
            <van-button  v-if="uploadFile.length > 0" size="small" type="info" @click="upload" :loading="loadingStatus">{{loadingStatus?'正在上传':'点击上传文件'}}
            </van-button>

            <!--        <div style="height: 10px"></div>-->
            <!--        <Select v-model="addPictureRecord.picType">-->
            <!--            <Option v-for="item in picTypeList" :value="item.val" :key="item.val">{{item.name}}</Option>-->
            <!--        </Select>-->
            <div style="height: 10px"></div>
            <div>
                <Table highlight-row size="small" @on-row-click="onRowClick" height="350" :columns="columns"
                       :data="pictureRecords"
                       ref="table"></Table>
            </div>
        </div>

        <!--    维修后图片    -->
        <div v-if="!showdiv">
            维修后
            <div style="height: 40px"></div>
            <div class="demo-upload-list" v-for="item in uploadList">
                <template v-if="item.status === 'finished'">
                    <img :src="item.url">
                    <div class="demo-upload-list-cover">
                        <Icon type="ios-eye-outline" @click.native="handleViewafter(item.name)"></Icon>
                        <!--     不设删除   -->
                        <!--        <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>-->
                    </div>
                </template>
                <template v-else>
                    <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                </template>
            </div>
            <!--  iview的组件  -->
            <Upload
                    ref="upload"
                    :show-upload-list="false"
                    :default-file-list="defaultListafter"
                    :on-success="handleSuccessafter"
                    :on-error="handleerror"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload"
                    type="select"
                    action="https://upload-z2.qiniup.com"
                    multiple
                    style="display: inline-block;width:58px;">
                <div style="width: 58px;height:58px;line-height: 58px;">
                    <Icon type="ios-camera" size="20"></Icon>
                </div>
            </Upload>
            <Modal title="图片预览" v-model="visibleafter">
                <!--      <img :src="imageurlafter" v-if="visible" style="width: 100%">-->
                <!--   <img :src="'https://pic.jianchengjt.com/' + item.picKey + '?imageView2/2/w/300/h/200'">-->


                <img @click="onPhotoClickafter"
                     :src="'https://pic.jianchengjt.com/' + itempicKeyafter + '?imageView2/2/w/300/h/200'"></img>


            </Modal>
            <!--        <div v-if="uploadFile !== null">上传文件: {{uploadFile.name}}-->
            <!--            <van-button type="info" @click="upload" :loading="loadingStatusafter">{{loadingStatusafter?'正在上传':'点击上传文件'}}-->
            <!--            </van-button>-->
            <!--        </div>-->
            <div v-if="uploadFile.length > 0" v-for="item in uploadFile">上传文件: {{item.file.name}}</div>
            <van-button  v-if="uploadFile.length > 0" size="small" type="info" @click="upload" :loading="loadingStatus">{{loadingStatus?'正在上传':'点击上传文件'}}
            </van-button>

            <!--        <div style="height: 10px"></div>-->
            <!--        <Select v-model="addPictureRecord.picType">-->
            <!--            <Option v-for="item in picTypeListafter" :value="item.val" :key="item.val">{{item.name}}</Option>-->
            <!--        </Select>-->
            <div style="height: 10px"></div>
            <div>
                <Table highlight-row size="small" @on-row-click="onRowClickafter" height="350" :columns="columnsafter"
                       :data="pictureRecordsafter"
                       ref="table"></Table>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import store from '@/store'
    import axios from 'axios'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
    } from 'vant'

    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);

    export default {
        inject: ['reload'],

        name: "renewal-Uploaderimage",
        data(){
            return{
                changebefore:'info',
                changeafter:'success',

                showdiv:true,

                uploadFile: [],
                uploadList: [],

                maintainOrderid:null,
                maintainpeList:[],

                //图片参数
                postParams: {
                    upload_token: null,
                    picKey:null
                },
                MaintainPicture:{
                    id:null,
                    picKey:null,
                    picType:null,
                    srcWidth:null,
                    srcHeight:null,
                },

                addPictureRecord: {
                    picKey: null,
                    srcHeight: null,
                    srcWidth: null,
                    picType: 1
                },

                loadingStatus: false,
                imgName: '',
                imageurl: '',
                itempicKey: '',
                visible: false,
                defaultList:[],
                columns: [
                    {
                        title: 'picKey',
                        key: 'picKey',
                        ellipsis: 'true',
                        minWidth: 250,
                    },
                    {
                        title: '图片类型',
                        key: 'picType',
                        ellipsis: 'true',
                        minWidth: 100,
                        render: (h, params) => {
                            console.log(params)
                            return h('Select', {
                                    style: {width: '80px'},
                                    props: {
                                        // value: this.data[params.index].volumeType,
                                        value: params.row.picType,
                                        disabled: !params.row.modify
                                    },
                                    on: {
                                        'on-change': (event) => {
                                            params.row.picType = event
                                            console.log(params.row.picType)
                                        }
                                    }
                                },
                                [
                                    h('Option', {
                                        props: {
                                            value: 1
                                        }
                                    }, '维修前图片'),
                                ]
                            );
                        }
                    },
                ],
                picTypeList: [
                    {name: '维修前图片', val: 1},
                ],
                pictureRecords: [],

                loadingStatusafter: false,
                imgNameafter: '',
                imageurlafter: '',
                itempicKeyafter:false,
                visibleafter:false,
                defaultListafter:[],
                columnsafter: [
                    {
                        title: 'picKey',
                        key: 'picKey',
                        ellipsis: 'true',
                        minWidth: 250,
                    },
                    {
                        title: '图片类型',
                        key: 'picType',
                        ellipsis: 'true',
                        minWidth: 100,
                        render: (h, params) => {
                            return h('Select', {
                                    style: {width: '80px'},
                                    props: {
                                        // value: this.data[params.index].volumeType,
                                        value: params.row.picType,
                                        disabled: !params.row.modify
                                    },
                                    on: {
                                        'on-change': (event) => {
                                            params.row.picType = event
                                            console.log(params.row.picType)
                                        }
                                    }
                                },
                                [
                                    h('Option', {
                                        props: {
                                            value: 4
                                        }
                                    }, '维修后图片'),
                                ]
                            );
                        }
                    },
                ],
                picTypeListafter: [
                    {name: '维修后图片', val: 2},
                ],
                pictureRecordsafter: [],
            }
        },
        methods:{
            //返回上一页
            onback(){
                this.$router.push({
                    name: 'maintainOrdersDetail',
                    params:{'maintainOrdersDetailid':this.$route.query.maintainOrdersUploaderimage}
                })
            },

            changediv(){
                if (this.showdiv) {
                    this.showdiv=false
                    this.changebefore = 'success'
                    this.changeafter = 'info'
                    this.addPictureRecord.picType = 2
                }else {
                    this.showdiv=true
                    this.changebefore = 'info'
                    this.changeafter = 'success'
                    this.addPictureRecord.picType = 1
                }
            },

            getpicture(e){
                this.maintainOrderid = e
                this.loadPhotoRecords(this.maintainOrderid)
            },

            /**
             * 上传组件方法
             * @param res
             * @param file
             */
            handleSuccess(res, file) {
                console.log('success'+file)
                // file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
                // file.name = '7eb99afb9d5f317c912f08b5212fd69a';
                // file.url = 'http://pic41.nipic.com/20140522/13975662_164750011385_2.jpg';
                //显示的图片，push
                this.defaultList.push(
                    {
                        'name': file.name,
                        'url': file.url
                    }
                )
            },
            handleSuccessafter(res, file) {
                console.log('success'+file)
                // file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
                // file.name = '7eb99afb9d5f317c912f08b5212fd69a';
                // file.url = 'http://pic41.nipic.com/20140522/13975662_164750011385_2.jpg';
                //显示的图片，push
                this.defaultListafter.push(
                    {
                        'name': file.name,
                        'url': file.url
                    }
                )
            },
            handleerror(file){
                Toast('上传失败'+file)
                console.log('error'+file)
            },
            //文件格式验证失败时的钩子，返回字段为 file, fileList
            handleFormatError(file) {
                console.log(file)
                this.$Notice.warning({
                    title: 'The file format is incorrect',
                    desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
                });
            },
            //限制图片大小
            handleMaxSize(file) {
                this.$Notice.warning({
                    title: 'Exceeding file size limit',
                    desc: 'File  ' + file.name + ' is too large, no more than 2M.'
                });
            },
            //上传文件之前的钩子，参数为上传的文件，若返回 false 或者 Promise 则停止上传
            handleBeforeUpload(file) {
                let that = this;
                // Toast('text!!!')
                // const check = this.uploadList.length < 5;
                // if (!check) {
                //  this.$Notice.warning({
                //   title: 'Up to five pictures can be uploaded.'
                //  });
                // }


                //获取七牛上传凭证
                store.dispatch('PictureServ_GetQiniuUploadToken', {
                    params: {
                        head: 'MAINTAINORDER'
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    // that.MaintainPicture.upload_token = store.getters.get_Picture_GetQiniuUploadTokenResult.uploadToken
                    // that.MaintainPicture.picKey = store.getters.get_Picture_GetQiniuUploadTokenResult.photoKey
                    // that.uploadFile = file;
                    let uploadToken = store.getters.get_Picture_GetQiniuUploadTokenResult.uploadToken
                    let photoKey = store.getters.get_Picture_GetQiniuUploadTokenResult.photoKey
                    that.uploadFile.push({file,uploadToken,photoKey})
                    // this.upload()
                })
                    .catch((err) => {
                        console.log(err)
                    })

                return false;
            },




            /**
             * 维修前图片
             */
            loadPhotoRecords(e) {
                this.pictureRecords = []
                this.pictureRecordsafter = []
                store.dispatch('MaintainOrderServ_GetDetail', {
                    params: {id: this.$route.query.maintainOrdersUploaderimage},
                    urlparams: null
                }).then((res) => {
                    // console.log(res)
                    let title = null
                    // let MaintainOrder = store.getters.get_MaintainOrder_GetDetailResult
                    // let maintainDeviceRecords = MaintainOrder.maintainDeviceRecords
                    for (let i = 0; i < store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords.length; i++) {
                        // console.log(maintainDeviceRecords[i])
                        // console.log(e)
                        if (e == store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords[i].id) {
                            for (let j = 0; j < store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords[i].beforePics.length; j++) {
                                console.log(store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords[i].beforePics[j])
                                this.pictureRecords.push(store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords[i].beforePics[j])
                            }
                            for (let j = 0; j < store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords[i].afterPics.length; j++) {
                                console.log(store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords[i].afterPics[j])
                                this.pictureRecordsafter.push(store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords[i].afterPics[j])
                            }
                        }
                    }
                }).catch(err => {
                    console.log('维修前图片'+err)
                    this.$Message.error(err)
                })
            },
            handleView(name) {
                console.log(name)
                for (let i = 0; i < this.defaultList.length; i++) {
                    // console.log(this.defaultList[i].name)
                    if (name == this.defaultList[i].name) {
                        this.imageurl = this.defaultList[i].url
                    }
                }
                this.imgName = name;
                this.visible = true;
            },
            onRowClick(item, index) {
                console.log(item.picKey)
                // console.log(index)
                this.visible = true
                this.itempicKey = item.picKey
                this.currentPictureIndex = index;
                let item2 = this.pictureRecords[this.currentPictureIndex]
                // window.open('https://pic.jianchengjt.com/' + item2.picKey)
            },
            onPhotoClick() {

                for (let i = 0; i < this.pictureRecords.length; i++) {

                }

                let item = this.pictureRecords[this.currentPictureIndex]
                window.open('https://pic.jianchengjt.com/' + item.picKey)
            },

            /**
             * 维修后图片
             */
            handleViewafter(name) {
                console.log(name)
                for (let i = 0; i < this.defaultListafter.length; i++) {
                    // console.log(this.defaultList[i].name)
                    if (name == this.defaultListafter[i].name) {
                        this.imageurlafter = this.defaultListafter[i].url
                    }
                }
                this.imgNameafter = name;
                this.visibleafter = true;
            },
            onRowClickafter(item, index){
                console.log(item.picKey)
                // console.log(index)
                this.visibleafter = true
                this.itempicKeyafter = item.picKey
                this.currentPictureIndex = index;
                let item2 = this.pictureRecordsafter[this.currentPictureIndex]
                // window.open('https://pic.jianchengjt.com/' + item2.picKey)
            },
            onPhotoClickafter() {

                for (let i = 0; i < this.pictureRecordsafter.length; i++) {

                }

                let item = this.pictureRecordsafter[this.currentPictureIndex]
                window.open('https://pic.jianchengjt.com/' + item.picKey)
            },

            /**
             * 上传
             */
            upload() {
                console.log(this.uploadFile)
                for (let i = 0; i < this.uploadFile.length; i++) {
                    console.log('开始上传')
                    let param = new FormData(); //创建form对象
                    param.append('chunk', '0');//断点传输
                    param.append('chunks', '1');
                    param.append('token', this.uploadFile[i].uploadToken)
                    param.append('key', this.uploadFile[i].photoKey);
                    param.append('file', this.uploadFile[i].file, this.uploadFile[i].file.name)
                    console.log(this.uploadFile[i])

                    let config = {
                        // headers:{'X-Requested-with':'XMLHttpRequest'},
                        // headers:{'Content-Type':'application/json'},
                        headers: {'Content-Type': 'multipart/form-data'},
                        // headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}  // 这里是跨域的写法
                        withCredentials: false
                    };
                    if (this.showdiv){
                        this.loadingStatus = true;
                    } else {
                        this.loadingStatusafter = true;
                    }

                    // console.log(this.MaintainPicture.picKey)
                    // console.log(this.addPictureRecord.picType)
                    this.MaintainPicture.maintainDeviceRecordId = this.$route.query.maintainOrdersUploaderimage
                    this.MaintainPicture.picType = this.addPictureRecord.picType
                    this.MaintainPicture.srcWidth = this.addPictureRecord.srcWidth
                    this.MaintainPicture.srcHeight = this.addPictureRecord.srcHeight
                    let MaintainPicture = {
                        id:null,
                        picKey:null,
                        picType:null,
                        srcWidth:null,
                        srcHeight:null,
                    }
                    MaintainPicture.id = this.MaintainPicture.id
                    MaintainPicture.maintainDeviceRecordId = this.MaintainPicture.maintainDeviceRecordId
                    MaintainPicture.picType = this.addPictureRecord.picType
                    MaintainPicture.srcWidth = this.addPictureRecord.srcWidth
                    MaintainPicture.srcHeight = this.addPictureRecord.srcHeight
                    MaintainPicture.upload_token = this.uploadFile[i].uploadToken
                    MaintainPicture.picKey = this.uploadFile[i].photoKey
                    console.log(MaintainPicture)

                    axios.post('https://upload-z2.qiniup.com', param, config)
                        .then(response => {
                            console.log(response);
                            console.log(response.data);
                            // this.addPictureRecord.picKey = this.MaintainPicture.picKey

                            // console.log(this.addPictureRecord)
                            console.log(MaintainPicture)
                            console.log(this.MaintainPicture)
                            //  未完成的订单
                            //安装订单更换图片
                            store.dispatch('MaintainOrderServ_UploadMaintainPicture', {
                                params: MaintainPicture,
                                urlparams: null
                            }).then((res) => {
                                console.log(res)
                                this.loadingStatus = false
                                this.loadingStatusafter = false
                                Toast.success('添加图片成功')
                                this.uploadFile = null
                                this.reload()
                                /**
                                 * 异步调用导致列表长度不对，无法正常点击table打开图片
                                 */
                                // this.loadPhotoRecords(this.maintainOrderid)
                            }).catch(err => {
                                this.loadingStatus = false
                                this.loadingStatusafter = false
                                Toast(err)
                                console.log(err)
                            });
                        }).catch(err1 => {

                        Toast(err1)
                        console.log(err)
                        this.loadingStatus = false
                        this.loadingStatusafter = false
                    })
                }
                //     console.log('开始上传')
                //     let param = new FormData(); //创建form对象
                //     param.append('chunk', '0');//断点传输
                //     param.append('chunks', '1');
                //     param.append('token', this.MaintainPicture.upload_token)
                //     param.append('key', this.MaintainPicture.picKey);
                //     param.append('file', this.uploadFile, this.uploadFile.name)
                //     console.log(this.uploadFile)
                //
                //     let config = {
                //         // headers:{'X-Requested-with':'XMLHttpRequest'},
                //         // headers:{'Content-Type':'application/json'},
                //         headers: {'Content-Type': 'multipart/form-data'},
                //         // headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}  // 这里是跨域的写法
                //         withCredentials: false
                //     };
                //     if (this.showdiv){
                //         this.loadingStatus = true;
                //     } else {
                //         this.loadingStatusafter = true;
                //     }
                //
                //     // console.log(this.MaintainPicture.picKey)
                //     // console.log(this.addPictureRecord.picType)
                //     this.MaintainPicture.maintainDeviceRecordId = this.$route.query.maintainOrdersUploaderimage
                //     this.MaintainPicture.picType = this.addPictureRecord.picType
                //     this.MaintainPicture.srcWidth = this.addPictureRecord.srcWidth
                //     this.MaintainPicture.srcHeight = this.addPictureRecord.srcHeight
                //
                //     axios.post('https://upload-z2.qiniup.com', param, config)
                //         .then(response => {
                //             console.log(response);
                //             console.log(response.data);
                //             // this.addPictureRecord.picKey = this.MaintainPicture.picKey
                //
                //             // console.log(this.addPictureRecord)
                //
                //             //  未完成的订单
                //             //安装订单更换图片
                //             store.dispatch('MaintainOrderServ_UploadMaintainPicture', {
                //                 params: this.MaintainPicture,
                //                 urlparams: null
                //             }).then((res) => {
                //                 console.log(res)
                //                 this.loadingStatus = false
                //                 this.loadingStatusafter = false
                //                 Toast.success('添加图片成功')
                //                 this.uploadFile = null
                //                 this.reload()
                //                 this.loadPhotoRecords(this.maintainOrderid)
                //             }).catch(err => {
                //                 this.loadingStatus = false
                //                 this.loadingStatusafter = false
                //                 Toast(err)
                //             });
                //
                //         }).catch(err1 => {
                //         Toast(err1)
                //         this.loadingStatus = false
                //         this.loadingStatusafter = false
                //     })
            },
        },
        mounted() {
            this.$nextTick(() => {
                console.log(this.$route.query.maintainOrdersUploaderimage)
                let id = this.$route.query.maintainOrdersUploaderimage
                store.dispatch('MaintainOrderServ_GetDetail', {
                    params: { id: id },
                    urlparams: null
                }).then(() => {
                    console.log(store.getters.get_MaintainOrder_GetDetailResult)
                    if (store.getters.get_MaintainOrder_GetDetailResult) {
                        this.maintainpeList = store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords
                        // this.MaintainPicture.id = store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords[0].id
                    }
                    console.log(this.maintainpeList)
                }).catch(err =>{
                    this.$Message.error(err)
                })
            })
        },
    }
</script>

<style scoped>
    .demo-upload-list {
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
        margin-right: 4px;
    }

    .demo-upload-list-cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, .6);
    }
    #that {
        height: 100%;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
</style>
